import { Avatar, AvatarFallback, AvatarImage } from "@workspace/frontend-ui";
import type { FC } from "react";
import type { Loyalty } from "./types";
import XpIcon from "./XpIcon";

type Props = {
  loyalty: Loyalty;
  tierLabel: string;
  multiplierLabel: string;
};

const LoyaltyHeader: FC<Props> = ({ loyalty, tierLabel, multiplierLabel }) => {
  const fill = Math.min(Math.max(loyalty.progress, 0), 100);
  return (
    <div className="grid gap-2 rounded-lg bg-muted p-2">
      <div className="flex items-stretch gap-2">
        <div className="flex w-11 items-center justify-center rounded-lg bg-background px-1 py-1.5">
          <Avatar className="size-8">
            <AvatarImage src={loyalty.tierImgUrl} alt={loyalty.tierName} />
            <AvatarFallback>{loyalty.tierName.slice(0, 1)}</AvatarFallback>
          </Avatar>
        </div>
        <div className="flex flex-1 items-center justify-between gap-2 rounded-lg bg-background px-3 py-2">
          <div className="grid gap-0.5">
            <span className="text-[10px] text-muted-foreground leading-3">
              {tierLabel}
            </span>
            <span className="font-medium text-foreground text-sm">
              {loyalty.tierName}
            </span>
          </div>
          <div className="h-7 w-px bg-border" />
          <div className="grid gap-0.5">
            <span className="text-[10px] text-muted-foreground leading-3">
              {multiplierLabel}
            </span>
            <div className="flex items-center gap-1">
              <span className="font-medium text-foreground text-sm">
                x {loyalty.multiplier}
              </span>
              <XpIcon />
            </div>
          </div>
        </div>
      </div>
      <div className="relative flex h-4 items-center justify-center overflow-hidden rounded-full bg-background">
        <div
          className="absolute inset-y-0.5 left-0.5 rounded-full bg-primary"
          style={{ width: `${fill}%` }}
        />
        <span className="relative font-medium text-foreground text-xs">
          {loyalty.currentPoints} / {loyalty.targetPoints}
        </span>
      </div>
    </div>
  );
};

export default LoyaltyHeader;
